/**
 * © 2025. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 *
 * Manages fields, a replacement for JSON Schema.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "crossorigin",
    title: "Cross-Origin",
    description: "This tells requests how it's handled. Valid values are 'anonymous', 'use-credentials', '*', or empty string.",
    type: "field",
    use: {
        namespace: "ua.select"
    },
    tests: {
        validAnonymous: {
            must: true,
            run: function () {
                return validate({ title: "Cross-Origin" }, "anonymous");
            }
        },
        validUseCredentials: {
            must: true,
            run: function () {
                return validate({ title: "Cross-Origin" }, "use-credentials");
            }
        },
        validEmpty: {
            must: true,
            run: function () {
                return validate({ title: "Cross-Origin" }, "");
            }
        },
        validWildcard: {
            must: true,
            run: function () {
                return validate({ title: "Cross-Origin" }, "*");
            }
        },
        invalidValue: {
            throw: "fields.crossorigin.invalid",
            run: function () {
                return validate({ title: "Cross-Origin" }, "something-else");
            }
        },
        invalidType: {
            throw: "fields.crossorigin.notString",
            run: function () {
                return validate({ title: "Cross-Origin" }, 123);
            }
        }
    },
    errors: {
        notString: {
            title: "Invalid Type",
            description: "The crossorigin value must be a string.",
            template: "Expected string but received ${typeof}"
        },
        invalid: {
            title: "Invalid Cross-Origin Value",
            description: "The crossorigin attribute must be 'anonymous', 'use-credentials', '*', or an empty string.",
            template: "Invalid crossorigin value: '${value}'. Must be 'anonymous', 'use-credentials', '*', or empty."
        }
    }
});

var validValues = ["anonymous", "use-credentials", "*", ""];

function validate(spec, value) {
    if (typeof value !== "string") {
        _.errors.notString.throw({ typeof: typeof value });
    }

    if (!validValues.includes(value)) {
        _.errors.invalid.throw({ value: value });
    }
}
module.exports.validate = validate;
